import 'css-chunksrc/client/pages/obsPage/tree/styles.scss';export default {
  "tree": "_tree_1a0e4_1"
};